import React from "react";
import LoginAside from "../components/LoginAside";
import LoginForm from "../components/LoginForm";
function LoginLayout(){
    return (
        <div className="d-flex flex-column flex-root" id="kt_app_root">
            <div className="d-flex flex-column flex-lg-row flex-column-fluid">
               
                <LoginForm />
            </div>
        </div>

    );
}
export default LoginLayout;